import { Injectable, Injector } from '@angular/core';
import { TestBed } from '@angular/core/testing';

@Injectable({
  providedIn: 'root'
})
export class ServiceLocator {
  static injector: Injector;
  static testBed: TestBed;

  static get<T>(token: any): T {
    if (!ServiceLocator.injector && !ServiceLocator.testBed) {
      throw new Error(
        'Injector has not been set. Please ensure ServiceLocator.injector is assigned during app initialization.'
      );
    }
    if (ServiceLocator.injector) {
      return ServiceLocator.injector.get<T>(token);
    }
    return ServiceLocator.testBed.inject<T>(token);
  }
}
